import React, { useState, useEffect, useRef } from "react";
import Button from "../../components/button/Button";
import "./giftcardrates.css";
import GiftCardRateTable from "../../components/giftcardratesTable/GiftCardRateTable";
import NavBar from "../../Nav Bar/NavBar";
import ColoredLogo from "../../assets/ColoredLogo.svg";
import ResultNotFound from "../resultNotFound/ResultNotFound";
import axios from "axios";

const GiftCardRates = () => {
  const [cardsRate, setCardsRate] = useState([]);
  const [searchQuery, setSearchQuery] = useState(""); // State for search input
  const [filteredRates, setFilteredRates] = useState([]); // State for filtered results
  const [loading, setLoading] = useState(true); // Loading state
  const [isSearchFocused, setIsSearchFocused] = useState(false); // State for search input focus
  const contentRef = useRef(null); // Reference for contentEditable div

  // Fetch data from the API
  useEffect(() => {
    const params = new URLSearchParams();
    params.append("appid", "android-v1");
    params.append("sign", "8c5ce752342c23686d3f613208949305");
    params.append("country_id", "14");

    axios
      .post("https://api.giftcard8.com/gc/card/list", params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((response) => {
        const data = response.data.data;
        setCardsRate(data);
        setFilteredRates(data); // Initialize filtered rates with full data
      })
      .catch((error) => {
        console.error("API Request Failed:", error);
      })
      .finally(() => {
        setLoading(false); // Stop loading when data is fetched
      });
  }, []);

  // Filter results based on searchQuery
  useEffect(() => {
    if (!searchQuery.trim()) {
      setFilteredRates(cardsRate); // Reset to full list if search query is empty
      return;
    }

    const filtered = cardsRate.filter((rate) =>
      rate.category_name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredRates(filtered);
  }, [searchQuery, cardsRate]);

  const [currentDateTime, setCurrentDateTime] = useState("");

  // Format the current date and time
  useEffect(() => {
    const now = new Date();
    const formattedDateTime = `${now.getFullYear()}-${String(
      now.getMonth() + 1
    ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")} / (${String(
      now.getHours()
    ).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(
      now.getSeconds()
    ).padStart(2, "0")})`;
    setCurrentDateTime(formattedDateTime);
  }, []);

  const handleFocus = () => setIsSearchFocused(true);
  const handleBlur = () => setIsSearchFocused(false);
  const handleInput = () => {
    if (contentRef.current) {
      setSearchQuery(contentRef.current.innerText);
    }
  };

  return (
    <>
      <NavBar linkColor="#000" logo={ColoredLogo} bg="#fff" />
      <div
        className="container py-5 d-flex flex-column justify-content-center align-items-center"
        style={{ marginTop: "100px" }}
      >
        <h1 className="w-100 text-center">
          The #1 Best Rates of Gift card
          <br /> Sellers in Nigeria
        </h1>
        <div className="d-flex justify-content-center align-items-center w-100 w-sm-100 w-md-50">
          <Button
            className="w-25 responsive-button hover-effect contBtn"
            actionType="redirect"
            redirectUrl="https://dashboard.giftcard8.com/account"
          >
            Sell Now
          </Button>
        </div>
      </div>

      <div
        className="container mb-5 search-container d-flex align-items-center SGRSection"
        style={{ width: "85%" }}
      >
        <div className="input-group d-flex align-items-center mt-1">
          <i className="bi bi-search me-2"></i>
          <div
            className="search-div"
            style={{
              width: "96%",
              borderRadius: ".375rem",
              minHeight: "30px",
              outline: "none",
            }}
          >
            <div
              ref={contentRef}
              className="form-control rounded-3 text-left"
              contentEditable="true"
              onFocus={handleFocus}
              onBlur={handleBlur}
              onInput={handleInput}
              suppressContentEditableWarning={true} // Add this line
              style={{
                border: "none",
                outline: "none",
                flex: 1,
                height: "40px",
                fontSize: "18px",
                backgroundColor: "transparent",
                color: searchQuery.trim() ? "black" : "#6c757d",
              }}
            >
              {!isSearchFocused && !searchQuery && "Search giftcards"}
            </div>
          </div>
        </div>
      </div>

      <div className="container mb-5 SGRSection2" style={{ width: "87%" }}>
        <div className="row align-items-center">
          <div className="col-12 col-md-6">
            <h1 className="text-center text-md-start fs-1">Gift Card Rates</h1>
          </div>
          <div className="col-12 col-md-6 d-flex justify-content-center justify-content-md-end">
            <div className="bg-dark rounded-3 p-3 hover-effect">
              <h6 className="m-0 px-3 fs-6" style={{ color: "#fff" }}>
                Current Rates:{" "}
                <span className="fw-bold">{currentDateTime}</span>
              </h6>
            </div>
          </div>
        </div>
      </div>

      {loading ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <div
            style={{
              display: "flex",
              gap: "20px",
              alignItems: "center",
              padding: "20px",
              backgroundColor: "#f0f0f0",
              borderRadius: "8px",
            }}
          >
            <div
              style={{
                width: "100px",
                height: "100px",
                backgroundColor: "#e0e0e0",
                borderRadius: "4px",
              }}
            ></div>
            <div
              style={{
                width: "200px",
                height: "20px",
                backgroundColor: "#e0e0e0",
                borderRadius: "4px",
              }}
            ></div>
            <div
              style={{
                width: "300px",
                height: "15px",
                backgroundColor: "#e0e0e0",
                marginTop: "10px",
                borderRadius: "4px",
              }}
            ></div>
          </div>
        </div>
      ) : filteredRates.length > 0 ? (
        filteredRates.map((rate) => (
          <GiftCardRateTable
            key={rate.category_id}
            logo={rate.category_logo_img}
            cardName={rate.category_name}
            list={rate.list}
          />
        ))
      ) : (
        <ResultNotFound />
      )}

      <div className="mb-5"></div>
    </>
  );
};

export default GiftCardRates;
